// @core/api/endpoints/authn/unlink_oauth2_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UnlinkOAuth2AccountRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Unlink OAuth2 account from user
 * Removes the association between an external OAuth2 provider account and the current user. The user must have at least one other authentication method available.
 */
export async function UnlinkOAuth2Account(
  data: UnlinkOAuth2AccountRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/external/unlink`;
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
